import React, { useState, useMemo, useEffect,useRef } from "react";
import { Toast } from "primereact/toast";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { Calendar } from "primereact/calendar";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from "axios";
import "./BookingCalander.css";
import { IoClose } from "react-icons/io5";
import {
  getPrice,
  bookSlot,
  getReservedslot,
  // getSpecificourt,
} from "../../Services/BackendUrl";
import { FaCheck } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { encryptedAuth } from "../../Services/EncryptData";

const BookingCalendar = () => {
  // const BOOKING_EVENTS_KEY = "bulkBookingEvents";
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [bookedEvents, setBookedEvents] = useState([]);
  const [courtNo, setCourtNo] = useState(1);
  const availableCourts = [1, 2, 3, 4, 5, 6, 7];
  const [showDialog, setShowDialog] = useState(false);
  const [basePrice, setBasePrice] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    playerCount: "",
    price: "",
    receipt: null,
  });
  const [errors, setErrors] = useState({});
  const toast = useRef(null);


  const isAllFieldsFilled =
    courtNo && startDate && endDate && startTime && endTime;

  const formatTo12HourString = (date) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const mins = minutes < 10 ? "0" + minutes : minutes;
    return `${hours.toString().padStart(2, "0")}:${mins}${ampm}`;
  };

  const formatDateWithoutTimezone = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getDateRange = (start, end) => {
    const range = [];
    const current = new Date(start);
    current.setHours(0, 0, 0, 0);
    const last = new Date(end);
    last.setHours(0, 0, 0, 0);
    while (current <= last) {
      range.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    return range;
  };

  const formatTo12Hour = (hour, minute) => {
    const period = hour >= 12 ? "pm" : "am";
    const hour12 = hour % 12 || 12;
    const minuteStr = minute.toString().padStart(2, "0");
    return `${hour12}:${minuteStr} ${period}`;
  };

  const normalizeToHour = (date) => {
    if (!date) return null;
    const d = new Date(date);
    d.setMinutes(0, 0, 0);
    return d;
  };

  // const mergeUniqueEvents = (baseEvents, nextEvents) => {
  //   const map = new Map();
  //   [...baseEvents, ...nextEvents].forEach((event) => {
  //     const key = `${event.courtNo}-${event.start}-${event.end}-${event.title}`;
  //     map.set(key, event);
  //   });
  //   return Array.from(map.values());
  // };

  // useEffect(() => {
  //   const fetchAvailability = async () => {
  //     if (!courtNo) return;
  //   try {
  //     const currentYear = new Date().getFullYear();
  //     const fromDate = `${currentYear}-01-01`;
  //     const toDate = `${currentYear + 5}-12-31`;
  //     const payload = {
  //       fromDate,
  //       toDate,
  //         courtNo: courtNo.toString(),
  //     };

  //       const res = await axios.post(
  //         courtAvailability,
  //         payload,
  //         { headers: { "Content-Type": "application/json" } }
  //       );

  //     const data = res.data.availability || {};
  //     const newEvents = [];

  //     Object.entries(data).forEach(([date, slots]) => {
  //         Object.entries(slots).forEach(([slotKey, slotValue]) => {
  //         const { time, status } = slotValue;
  //         if (status === "available" || status === "disabled") return;

  //         const timeParts = time.match(/(\d+):(\d+)(am|pm)/i);
  //         if (!timeParts) return;
  //         // eslint-disable-next-line
  //         let [_, hh, mm, period] = timeParts;
  //         let hour = parseInt(hh);
  //         if (period.toLowerCase() === "pm" && hour !== 12) hour += 12;
  //         if (period.toLowerCase() === "am" && hour === 12) hour = 0;

  //         const eventStart = new Date(
  //           `${date}T${hour.toString().padStart(2, "0")}:${mm}:00`
  //         );
  //         const eventEnd = new Date(eventStart);
  //         eventEnd.setHours(eventStart.getHours() + 1);

  //         newEvents.push({
  //           title: `${time.toLowerCase()} (${status})`,
  //           start: eventStart.toISOString(),
  //           end: eventEnd.toISOString(),
  //           backgroundColor: "rgba(255,0,0,0.8)",
  //           borderColor: "rgba(255,0,0,0.8)",
  //             courtNo,
  //         });
  //       });
  //     });

  //       setBookedEvents(newEvents);
  //   } catch (err) {
  //     console.error("Error fetching court availability:", err);
  //   }
  // };

  //   fetchAvailability();
  // }, [courtNo]);

useEffect(() => {
  const fetchPrice = async () => {
    if (!showDialog) return;
    try {
      const res = await axios.get(getPrice);
      if (res.data && res.data.price) {
        setBasePrice(Number(res.data.price));
      }
    } catch (err) {
      console.error("Error fetching price:", err);
    }
  };
  fetchPrice();
}, [showDialog]);

useEffect(() => {
  if (!basePrice || !startDate || !endDate || !startTime || !endTime) return;

  const hoursDiff = Math.abs(endTime - startTime) / (1000 * 60 * 60); 
  const daysDiff =
    Math.floor(
      (endDate.setHours(0, 0, 0, 0) - startDate.setHours(0, 0, 0, 0)) /
        (1000 * 60 * 60 * 24)
    ) + 1;

  const totalPrice = basePrice * hoursDiff * daysDiff;

  setFormData((prev) => ({
    ...prev,
    price: totalPrice.toFixed(2),
  }));
}, [basePrice, startDate, endDate, startTime, endTime]);

  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const phoneRegex = /^[0-9]{10}$/;
    const numberRegex = /^[0-9]+$/;

    if (!formData.name.trim()) newErrors.name = "Full name is required";
    else if (!nameRegex.test(formData.name))
      newErrors.name = "Name must contain only letters";

    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Invalid email format";

    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    // else if (!phoneRegex.test(formData.phone))
    //   newErrors.phone = "Enter a valid 10-digit phone number";

    if (!formData.playerCount.trim())
      newErrors.playerCount = "Player count is required";
    else if (!numberRegex.test(formData.playerCount) || formData.playerCount <= 0)
      newErrors.playerCount = "Enter a valid number of players";

    if (!formData.price.trim()) newErrors.price = "Price is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleBookDates = () => {
  if (startDate > endDate) {
   toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#FF7F5077",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <GrClose size={24} />
          <span className="font-medium">
            Invalid Time Selection
          </span>
        </div>
      ),
    });
  }
 
    if (startTime >= endTime) {
   toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#FF7F5077",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <GrClose size={24} />
          <span className="font-medium">
            Invalid Time Selection
          </span>
        </div>
      ),
    });
    return;
  }
  setShowDialog(true);
};

const getReserved = async () => {
  try {
    const res = await axios.get(getReservedslot, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Encrypted ${encryptedAuth}`,
      },
    });

    const bookings = res.data.bookings;

    const events = [];

    bookings.forEach((booking) => {
      const startDate = new Date(booking.fromDate);
      const endDate = booking.toDate
        ? new Date(booking.toDate)
        : new Date(booking.fromDate);

      let current = new Date(startDate);

      while (current <= endDate) {
        const start = new Date(current);
        const end = new Date(current);

        const convertTime = (time) => {
          const [t, modifier] = time.match(/(\d+:\d+)(AM|PM)/i).slice(1);
          let [hours, minutes] = t.split(":");

          hours = parseInt(hours);

          if (modifier.toUpperCase() === "PM" && hours !== 12) hours += 12;
          if (modifier.toUpperCase() === "AM" && hours === 12) hours = 0;

          return { hours, minutes: parseInt(minutes) };
        };

        const fromTime = convertTime(booking.from);
        const toTime = convertTime(booking.to);

        start.setHours(fromTime.hours, fromTime.minutes, 0);
        end.setHours(toTime.hours, toTime.minutes, 0);

        events.push({
          title: `${booking.from} - ${booking.to} (booked)`,
          start: start.toISOString(),
          end: end.toISOString(),
          courtNo: Number(booking.courtNo),
          backgroundColor: "red",
          borderColor: "red",
        });

        current.setDate(current.getDate() + 1);
      }
    });

    setBookedEvents(events);
  } catch (error) {
    console.error("Error:", error);
  }
};
  useEffect(()=>{
    getReserved()
  },[])


  const handleSubmitBooking = async () => {
  if (!validateForm()) return;

  try {
    const fromDate = formatDateWithoutTimezone(startDate);
    const toDate = formatDateWithoutTimezone(endDate);
    const from = formatTo12HourString(startTime);
    const to = formatTo12HourString(endTime);

    const bookingData = {
      courtNo: Number(courtNo),
      fromDate,
      toDate,
      from,
      to,
      fullName: formData.name,
      mobileNumber: formData.phone,
      email: formData.email,
      playerCount: parseInt(formData.playerCount),
      price: parseFloat(formData.price),
    };

    const form = new FormData();
    form.append("data", JSON.stringify(bookingData));
    if (formData.receipt) {
      form.append("file", formData.receipt);
    }
    
    const response = await axios.post(
      bookSlot,
      form,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

     toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#63F52066",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <FaCheck size={24} />
          <span className="font-medium">
            {response.data.message || "Booking successful!"}
          </span>
        </div>
      ),
    });

    const dateRange = getDateRange(startDate, endDate);
    const newEvents = dateRange.map((d) => {
      const start = new Date(d);
      start.setHours(startTime.getHours(), startTime.getMinutes(), 0, 0);
      const end = new Date(d);
      end.setHours(endTime.getHours(), endTime.getMinutes(), 0, 0);

      return {
        title: `${formatTo12Hour(
          startTime.getHours(),
          startTime.getMinutes()
        )}-${formatTo12Hour(endTime.getHours(), endTime.getMinutes())} (booked)`,
        start: start.toISOString(),
        end: end.toISOString(),
        backgroundColor: "rgba(255,0,0,0.8)",
        borderColor: "red",
        courtNo,
      };
    });

    setBookedEvents((prev) => [...prev, ...newEvents]);
    resetInputs();
    setShowDialog(false);
  } catch (error) {
    const errorMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    "Something went wrong";
    // console.error("❌ Booking failed:", error);

 toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#FF7F5077",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <GrClose size={24} />
          <span className="font-medium">
            {errorMessage}. The selected time is already booked.
            {/* booking failed. Please try again! */}
          </span>
        </div>
      ),
    });
  }
};

  const resetInputs = () => {
    setStartDate(null);
    setEndDate(null);
    setStartTime(null);
    setEndTime(null);
    setFormData({
      name: "",
      email: "",
      phone: "",
      playerCount: "",
      price: "",
      receipt: null,
    });
    setErrors({});
  };

  const filteredEvents = useMemo(() => {
    if (!courtNo) return [];
    return bookedEvents.filter((b) => b.courtNo === courtNo);
  }, [bookedEvents, courtNo]);

  return (
    <div className="calendar-container p-6 text-white">
      <Toast ref={toast} />
      <p className="text-3xl font-bold text-center mb-4 uppercase">
        Bulk Booking
      </p>

      <div className="flex justify-center mb-6">
        <select
          value={courtNo}
          onChange={(e) => setCourtNo(Number(e.target.value))}
          className="bg-transparent border border-gray-400 text-white px-4 py-2 rounded-md text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
        >
          {availableCourts.map((num) => (
            <option key={num} value={num} className="text-black">
              Court {num}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-wrap justify-center gap-6 mb-6">
        <Calendar
          value={startDate}
          onChange={(e) => setStartDate(e.value)}
          dateFormat="dd-mm-yy"
          placeholder="Start Date"
          className="new-calendar"
          minDate={new Date()}
        />
        <Calendar
          value={endDate}
          onChange={(e) => setEndDate(e.value)}
          dateFormat="dd-mm-yy"
          placeholder="End Date"
          className="new-calendar"
          
          minDate={startDate || new Date()}
        />
        <Calendar
          value={startTime}
          onChange={(e) => setStartTime(normalizeToHour(e.value))}
          timeOnly
          hourFormat="12"
          placeholder="Start Time"
          className="new-calendar"
          appendTo='self'
          stepMinute={60}
        />
        <Calendar
          value={endTime}
          onChange={(e) => setEndTime(normalizeToHour(e.value))}
          timeOnly
          hourFormat="12"
          placeholder="End Time"
          className="new-calendar"
          appendTo='self'
          stepMinute={60}
        />
      </div>

      <div className="flex justify-center mb-6">
        <button
          onClick={handleBookDates}
          disabled={!isAllFieldsFilled}
          className={`px-6 py-2 rounded-lg font-semibold transition ${
            isAllFieldsFilled
              ? "bg-orange-500 hover:bg-orange-600 text-white cursor-pointer"
              : "bg-gray-600 text-gray-300 cursor-not-allowed"
          }`}
        >
          BOOK
        </button>
      </div>

      <FullCalendar
  plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
  initialView="dayGridMonth"
  headerToolbar={{
    left: "prev,next today",
    center: "title",
    right: "dayGridMonth,timeGridWeek,timeGridDay",
  }}
  slotMinTime="05:00:00"
  slotMaxTime="24:00:00"
  allDaySlot={false}
  events={filteredEvents}
  height="100vh"
  displayEventTime={false}
  initialDate={new Date()} 
 validRange={{
  start: `${new Date().getFullYear()}-01-01`,
  end: `${new Date().getFullYear() + 10}-12-31`,
}}

/>

      {showDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-[400px] p-6 relative animate-fadeIn">
            <button
              onClick={() => setShowDialog(false)}
              className="absolute  top-6 right-4 bg-transparent border-none cursor-pointer"
            >
              <IoClose size={30} />
            </button>

            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              Booking Details
            </h2>

            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Full Name*
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  placeholder="Enter full name"
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.name
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.name && (
                  <span className="text-sm text-red-500">{errors.name}</span>
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">Email*</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  placeholder="Enter email"
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.email
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.email && (
                  <span className="text-sm text-red-500">{errors.email}</span>
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Phone Number*
                </label>
                <input
                  type="text"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                  placeholder="Enter the number"
                  onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
                  // maxLength={10}
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.phone
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.phone && (
                  <span className="text-sm text-red-500">{errors.phone}</span>
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Player Count*
                </label>
                <input
                  type="number"
                  min={0}
                  value={formData.playerCount}
                  onChange={(e) =>
                    setFormData({ ...formData, playerCount: e.target.value })
                  }
                  placeholder="Enter player count"
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.playerCount
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.playerCount && (
                  <span className="text-sm text-red-500">
                    {errors.playerCount}
                  </span>
                )}
              </div>

<div className="flex flex-col gap-2">
  <label className="font-semibold text-gray-700">Price (OMR)*</label>
  <input
    // type="number"
    // value={formData.price}
    // value={formData.playerCount}
    onChange={(e) =>
      setFormData({ ...formData, price: e.target.value })
    }
    // readOnly
    placeholder="Enter the price"
    onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
    className="border rounded-md px-3 py-2 bg-gray-100 text-gray-700 outline-none"
  />
</div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Payment Receipt (optional)
                </label>
                <label className="cursor-pointer bg-blue-500 text-white px-4 py-2 rounded-md w-fit hover:bg-blue-600 transition">
                  Upload
                  <input
  type="file"
  accept=".pdf, image/jpeg, image/png"
  className="hidden"
  onChange={(e) =>
    setFormData({
      ...formData,
      receipt: e.target.files?.[0],
    })
  }
/>
                </label>
              </div>
            </div>

            <button
              onClick={handleSubmitBooking}
              className="w-full mt-6 border-none bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-md transition cursor-pointer"
            >
              Submit Booking
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingCalendar;